module.exports = __webpack_public_path__ + "static/img/teach0.71afdeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching/teach0.png
// module id = FzNW
// module chunks = 0